import { CUSTOM_ELEMENTS_SCHEMA, Component, DestroyRef, HostListener, Inject, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { DrawerModule } from '../../Component/drawer';
import { LUCIDE_ICONS, LucideAngularModule, LucideIconProvider, icons } from 'lucide-angular';
import { MnDropdownComponent } from '../../Component/dropdown';
import { LanguageService } from '../../core/services/language.service';
import { Store } from '@ngrx/store';
import {
  getLayout,
  getLayoutmode,
  getSidebarcolor,
  getSidebarsize,
  getTopbarcolor,
} from '../../store/layout/layout-selector';
import { changeMode, changesidebarcolor, changesidebarsize, changetopbarcolor } from '../../store/layout/layout-action';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../core/services/auth.service';
import { SettingsService } from '../../core/services/settings.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [DrawerModule, MnDropdownComponent, LucideAngularModule, SimplebarAngularModule, RouterModule, CommonModule],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: LUCIDE_ICONS, multi: true, useValue: new LucideIconProvider(icons) }, LanguageService],
})
export class TopbarComponent implements OnInit {
  mode: any;
  size: any;

  private store = inject(Store);
  private authService = inject(AuthenticationService);
  private settingsService = inject(SettingsService);
  private destroyRef = inject(DestroyRef);
  layout: any;

  cantidadModulos: number = 0;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    const windowSize = document.documentElement.clientWidth;

    // Get Layout
    this.store
      .select(getLayout)
      .pipe(take(1))
      .subscribe(data => {
        this.layout = data;
      });

    if (this.layout == 'vertical') {
      if (windowSize > 768 && windowSize < 1024) {
        this.store.dispatch(changesidebarsize({ size: 'sm' }));
      } else {
        this.store.dispatch(changesidebarsize({ size: 'lg' }));
      }
    } else {
      this.store.dispatch(changesidebarsize({ size: 'lg' }));
    }
  }

  ngOnInit(): void {
    this.authService.cantidadModulos$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((cantidad: number) => {
      this.cantidadModulos = cantidad;
    });
  }

  // scroll
  windowScroll() {
    const scrollUp = document.documentElement.scrollTop;
    if (scrollUp >= 50) {
      document.getElementById('page-topbar')?.classList.add('is-sticky');
    } else {
      document.getElementById('page-topbar')?.classList.remove('is-sticky');
    }
  }

  // Mode Change
  changeLayoutMode() {
    this.store
      .select(getLayoutmode)
      .pipe(take(1))
      .subscribe(mode => {
        this.mode = mode;
      });
    if (this.mode == 'light') {
      this.store.dispatch(changeMode({ mode: 'dark' }));
      this.store.dispatch(changesidebarcolor({ sidebar: 'dark' }));
      this.store.dispatch(changetopbarcolor({ topbar: 'dark' }));
      this.store
        .select(getLayoutmode)
        .pipe(take(1))
        .subscribe(mode => {
          document.documentElement.setAttribute('data-mode', mode);
        });
      this.store
        .select(getSidebarcolor)
        .pipe(take(1))
        .subscribe(color => {
          document.documentElement.setAttribute('data-sidebar', color);
        });
      this.store
        .select(getTopbarcolor)
        .pipe(take(1))
        .subscribe(topbar => {
          document.documentElement.setAttribute('data-topbar', topbar);
        });
    } else {
      this.store.dispatch(changeMode({ mode: 'light' }));
      this.store.dispatch(changesidebarcolor({ sidebar: 'light' }));
      this.store.dispatch(changetopbarcolor({ topbar: 'light' }));
      this.store
        .select(getLayoutmode)
        .pipe(take(1))
        .subscribe(mode => {
          document.documentElement.setAttribute('data-mode', mode);
        });
      this.store
        .select(getSidebarcolor)
        .pipe(take(1))
        .subscribe(color => {
          document.documentElement.setAttribute('data-sidebar', color);
        });
      this.store
        .select(getTopbarcolor)
        .pipe(take(1))
        .subscribe(topbar => {
          document.documentElement.setAttribute('data-topbar', topbar);
        });
    }
  }

  changeSidebar() {
    const windowSize = document.documentElement.clientWidth;
    const sidebarOverlay = document.getElementById('sidebar-overlay') as any;

    if (windowSize < 768) {
      this.document.body.classList.add('overflow-hidden');
      // Check if the sidebar overlay is hidden
      if (sidebarOverlay.classList.contains('hidden')) {
        sidebarOverlay.classList.remove('hidden');
        this.document.documentElement.querySelector('.app-menu')?.classList.remove('hidden');
      } else {
        sidebarOverlay.classList.add('hidden');
        this.document.documentElement.querySelector('.app-menu')?.classList.add('hidden');
      }
      this.store.dispatch(changesidebarsize({ size: 'lg' }));
    } else {
      this.store
        .select(getSidebarsize)
        .pipe(take(1))
        .subscribe(size => {
          this.size = size;
        });
      this.store.dispatch(changesidebarsize({ size: this.size === 'sm' ? 'lg' : 'sm' }));
    }
  }

  /**
   * Limpia el localStorage y redirecciona al login de dashboard del Back Office pasando por query param el token
   */
  changeModule() {
    const token = this.authService.getAccessToken();
    localStorage.clear();
    window.location.href = `${this.settingsService.LOGIN_URL}?token=${token}`;
  }

  logout() {
    this.authService.logout();
  }
}
